/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * This directive allows Angular to listen for an Enter or Space keypress event and trigger a click on the element.
 * Should be combined with `tabindex="0"` to make an element tab-focusable if the element is not naturally tab-focusable.
 *
 * Usage example:
 * <span on-enter-space-click tabindex="0">
 *
 * @module enervee_utils.common
 */
onEnterSpaceClick.$inject = ['$timeout'];
function onEnterSpaceClick($timeout) {
    return function(scope, elem, attrs) {
        elem.bind('keydown keypress', function onKeyPress(e) {
            if (e.which === 13 || e.which === 32) {
                e.preventDefault();
                // Angular complains when trying to preventDefault and click the element in-sync, so $timeout is needed
                $timeout(function() {
                    elem.click();
                });
            }
        });
    };
}

module.exports = onEnterSpaceClick;